import axios, { AxiosResponse } from "axios";
import { ResponseApi } from "../types/ResponseApi";
import { ProyectoData } from "../interfaces/PROYECTOS/Proyectos";
import { InformesInvestigador, InitialInformesInvestigador } from "../interfaces/ITINERARIO/InformesInvestigador";

const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/ConsultasInv';

export default class ProyectoService {

    async GetProyectosByIdPersona(token: any): Promise<ResponseApi<ProyectoData>> {
        const response1: AxiosResponse<ResponseApi<ProyectoData>> =
            await axios.get(localBack + APICATALOGO + '/GetProyectosInvestigacionByIdPersona',
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
        //console.log(response1.data);        
        return response1.data;
    }


    async InformesPendientesProyectosEnEjec(token: any): Promise<ResponseApi<InformesInvestigador>> {
        try {
            const response1: AxiosResponse<ResponseApi<InformesInvestigador>> =
                await axios.get(localBack + APICATALOGO + '/GetInformesPendientesInvestigadorByIdPersona',
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api consulta'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: InitialInformesInvestigador(),
            };
        }
    }
}

